import r from "react";
import { selectClasses as c, outlinedInputClasses as d, menuClasses as n, FormControl as s, Select as u } from "@mui/material";
import { M as k, b as C } from "./MzInput-d411afb0.js";
import { s as f } from "./styled-38387a7e.js";
import "./createTheme-02ce03eb.js";
import "./useTheme-efe1290c.js";
import "./formControlState-9148c46f.js";
import "./useFormControl-c75d3f58.js";
import "./useThemeProps-ee4acb93.js";
import "./createSvgIcon-b5d2ebc3.js";
import "./createSvgIcon-9d6f669e.js";
import "./debounce-c2e7efcb.js";
import "./ownerWindow-a0b5b7a5.js";
import "./ownerDocument-5430cd5b.js";
import "./useEventCallback-fe4fd69c.js";
import "./useId-a21bd5c3.js";
import "./unsupportedProp-3dbf01f6.js";
import "./useControlled-cc2d41cb.js";
import "./useIsFocusVisible-4693b580.js";
import "@emotion/styled";
import "@emotion/react";
const A = f(b)(({ theme: t, noBorder: e }) => ({
  backgroundColor: t.palette.common.white,
  color: t.palette.darkBlue.c100,
  [`.${c.iconOutlined}`]: {
    backgroundColor: t.palette.darkBlue.c5,
    color: t.palette.darkBlue.c50
  },
  fieldset: {
    borderWidth: e ? 0 : "1px"
  },
  [`&:hover .${d.notchedOutline}`]: {
    borderColor: t.palette.darkBlue.c20
  }
})), x = {
  [`.${n.paper}`]: {
    ul: {
      margin: "0 8px"
    },
    li: {
      color: "darkBlue.c70",
      padding: "15px",
      "&:hover": {
        backgroundColor: "darkBlue.c5"
      }
    }
  }
};
function b({ label: t, helperText: e, error: l, size: m, fullWidth: i, required: p, MenuProps: o, ...a }) {
  return /* @__PURE__ */ r.createElement(s, { fullWidth: i, size: m }, t && /* @__PURE__ */ r.createElement(k, { required: p }, t), /* @__PURE__ */ r.createElement(u, { MenuProps: { ...o, sx: { ...x, ...o == null ? void 0 : o.sx } }, ...a }), /* @__PURE__ */ r.createElement(C, { error: l }, e));
}
export {
  A as default
};
